import { render, staticRenderFns } from "./transaction_types.vue?vue&type=template&id=293c28bd&scoped=true&"
import script from "./transaction_types.vue?vue&type=script&lang=js&"
export * from "./transaction_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c28bd",
  null
  
)

export default component.exports